import React, { useEffect, useState } from "react";
import Head from "../Global/Head";
import Header from "../Global/Header";
import Footer from "../shared/footer/Footer";
import LoginModal from "../main/loginModal/LoginModal";
import { useLocation } from "react-router-dom";

const Privacy = () => {
  return (
    <>
      <Head />
      <Header />
      <section className="terms-section  px-[24px] lightblack mgtop1rem">
        <div className="terms-div">
          <div className="terms-text w-richtext">
            <p>
              <strong>PRIVACY POLICY</strong>
            </p>
            <p>
              <strong>Last updated January 07, 2025</strong>
            </p>
            <p>
              This Privacy Notice for High Table Network Private Limited ("
              <strong>we</strong>," "<strong>us</strong>," or "
              <strong>our</strong>"), describes how and why we might access,
              collect, store, use, and/or share ("<strong>process</strong>")
              your personal information when you use our services ("
              <strong>Services</strong>"), including when you:
            </p>
            <ul role="list">
              <li>
                Visit our website at{" "}
                <a href="https://www.hightable.ai/" target="_blank">
                  https://www.hightable.ai
                </a>
                , or any website of ours that links to this Privacy Notice
              </li>
            </ul>
            <ul role="list">
              <li>
                Use HighTable. Meet a small group of strangers offline, where
                the goal is simple: good conversations and natural connections.
                No agendas, no pressure—just real moments and unplanned sparks.
                Whether it’s sharing a random thought or diving into something
                deeper, you never know where it might lead. Sometimes, the best
                connections happen when you least expect them.
              </li>
            </ul>
            <ul role="list">
              <li>
                Engage with us in other related ways, including any sales,
                marketing, or events
              </li>
            </ul>
            <p>
              <strong>Questions or concerns? </strong>Reading this Privacy
              Notice will help you understand your privacy rights and choices.
              We are responsible for making decisions about how your personal
              information is processed. If you do not agree with our policies
              and practices, please do not use our Services. If you still have
              any questions or concerns, please contact us at
              support@hightable.ai.
            </p>
            <p>
              <strong>SUMMARY OF KEY POINTS</strong>
            </p>
            <p>
              <strong>
                <em>
                  This summary provides key points from our Privacy Notice, but
                  you can find out more details about any of these topics by
                  clicking the link following each key point or by using our{" "}
                </em>
              </strong>
              <a href="#toc">
                <strong>
                  <em>table of contents</em>
                </strong>
              </a>
              <strong>
                <em> below to find the section you are looking for.</em>
              </strong>
            </p>
            <p>
              <strong>What personal information do we process?</strong> When you
              visit, use, or navigate our Services, we may process personal
              information depending on how you interact with us and the
              Services, the choices you make, and the products and features you
              use. Learn more about{" "}
              <a href="#personalinfo">
                personal information you disclose to us
              </a>
              .
            </p>
            <p>
              <strong>
                Do we process any sensitive personal information?{" "}
              </strong>
              Some of the information may be considered "special" or "sensitive"
              in certain jurisdictions, for example your racial or ethnic
              origins, sexual orientation, and religious beliefs. We do not
              process sensitive personal information.
            </p>
            <p>
              <strong>Do we collect any information from third parties?</strong>{" "}
              We do not collect any information from third parties.
            </p>
            <p>
              <strong>How do we process your information?</strong> We process
              your information to provide, improve, and administer our Services,
              communicate with you, for security and fraud prevention, and to
              comply with law. We may also process your information for other
              purposes with your consent. We process your information only when
              we have a valid legal reason to do so. Learn more about{" "}
              <a href="#infouse">how we process your information</a>.
            </p>
            <p>
              <strong>
                In what situations and with which parties do we share personal
                information?
              </strong>{" "}
              We may share information in specific situations and with specific
              third parties. Learn more about{" "}
              <a href="#whoshare">
                when and with whom we share your personal information
              </a>
              .
            </p>
            <p>
              <strong>How do we keep your information safe?</strong> We have
              adequate organizational and technical processes and procedures in
              place to protect your personal information. However, no electronic
              transmission over the internet or information storage technology
              can be guaranteed to be 100% secure, so we cannot promise or
              guarantee that hackers, cybercriminals, or other unauthorized
              third parties will not be able to defeat our security and
              improperly collect, access, steal, or modify your information.
              Learn more about{" "}
              <a href="#infosafe">how we keep your information safe</a>.
            </p>
            <p>
              <strong>What are your rights?</strong> Depending on where you are
              located geographically, the applicable privacy law may mean you
              have certain rights regarding your personal information. Learn
              more about <a href="#privacyrights">your privacy rights</a>.
            </p>
            <p>
              <strong>How do you exercise your rights?</strong> The easiest way
              to exercise your rights is by visiting __________, or by
              contacting us. We will consider and act upon any request in
              accordance with applicable data protection laws.
            </p>
            <p>
              Want to learn more about what we do with any information we
              collect? <a href="#toc">Review the Privacy Notice in full</a>.
            </p>
            <p>
              <strong>TABLE OF CONTENTS</strong>
            </p>
            <p>
              <a href="#infocollect">1. WHAT INFORMATION DO WE COLLECT?</a>
            </p>
            <p>
              <a href="#infouse">2. HOW DO WE PROCESS YOUR INFORMATION?</a>
            </p>
            <p>
              <a href="#whoshare">
                3. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?
              </a>
            </p>
            <p>
              <a href="#cookies">
                4. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?
              </a>
            </p>
            <p>
              <a href="#sociallogins">
                5. HOW DO WE HANDLE YOUR SOCIAL LOGINS?
              </a>
            </p>
            <p>
              <a href="#inforetain">6. HOW LONG DO WE KEEP YOUR INFORMATION?</a>
            </p>
            <p>
              <a href="#infosafe">7. HOW DO WE KEEP YOUR INFORMATION SAFE?</a>
            </p>
            <p>
              <a href="#infominors">
                8. DO WE COLLECT INFORMATION FROM MINORS?
              </a>
            </p>
            <p>
              <a href="#privacyrights">9. WHAT ARE YOUR PRIVACY RIGHTS?</a>
            </p>
            <p>
              <a href="#DNT">10. CONTROLS FOR DO-NOT-TRACK FEATURES</a>
            </p>
            <p>
              <a href="#policyupdates">
                11. DO WE MAKE UPDATES TO THIS NOTICE?
              </a>
            </p>
            <p>
              <a href="#contact">
                12. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?
              </a>
            </p>
            <p>
              <a href="#request">
                13. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT
                FROM YOU?
              </a>
            </p>
            <p>
              <strong>1. WHAT INFORMATION DO WE COLLECT?</strong>
            </p>
            <p>
              <strong>Personal information you disclose to us</strong>
            </p>
            <p>
              <strong>
                <em>In Short: </em>
              </strong>
              <em>We collect personal information that you provide to us.</em>
            </p>
            <p>
              We collect personal information that you voluntarily provide to us
              when you register on the Services, express an interest in
              obtaining information about us or our products and Services, when
              you participate in activities on the Services, or otherwise when
              you contact us.
            </p>
            <p>
              <strong>Personal Information Provided by You.</strong> The
              personal information that we collect depends on the context of
              your interactions with us and the Services, the choices you make,
              and the products and features you use. The personal information we
              collect may include the following:
            </p>
            <ul role="list">
              <li>names</li>
            </ul>
            <ul role="list">
              <li>phone numbers</li>
            </ul>
            <ul role="list">
              <li>email addresses</li>
            </ul>
            <ul role="list">
              <li>a bit about you - what makes you you</li>
            </ul>
            <p>
              <strong>Sensitive Information.</strong> We do not process
              sensitive information.
            </p>
            <p>
              <strong>Payment Data.</strong> We may collect data necessary to
              process your payment if you choose to make purchases, such as your
              payment instrument number, and the security code associated with
              your payment instrument. All payment data is handled and stored by
              Razor pay. You may find their privacy notice link(s) here:
              __________.
            </p>
            <p>
              <strong>Social Media Login Data. </strong>We may provide you with
              the option to register with us using your existing social media
              account details, like your Facebook, X, or other social media
              account. If you choose to register in this way, we will collect
              certain profile information about you from the social media
              provider, as described in the section called "
              <a href="#sociallogins">HOW DO WE HANDLE YOUR SOCIAL LOGINS?</a>"
              below.
            </p>
            <p>
              All personal information that you provide to us must be true,
              complete, and accurate, and you must notify us of any changes to
              such personal information.
            </p>
            <p>
              <strong>Google API</strong>
            </p>
            <p>
              Our use of information received from Google APIs will adhere to{" "}
              <a
                href="https://developers.google.com/terms/api-services-user-data-policy"
                target="_blank"
              >
                Google API Services User Data Policy
              </a>
              , including the{" "}
              <a
                href="https://developers.google.com/terms/api-services-user-data-policy#limited-use"
                target="_blank"
              >
                Limited Use requirements
              </a>
              .<br />
            </p>
            <p>
              <strong>2. HOW DO WE PROCESS YOUR INFORMATION?</strong>
            </p>
            <p>
              <strong>
                <em>In Short: </em>
              </strong>
              <em>
                We process your information to provide, improve, and administer
                our Services, communicate with you, for security and fraud
                prevention, and to comply with law. We may also process your
                information for other purposes with your consent.
              </em>
            </p>
            <p>
              <strong>
                We process your personal information for a variety of reasons,
                depending on how you interact with our Services, including:
              </strong>
            </p>
            <ul role="list">
              <li>
                <strong>
                  To facilitate account creation and authentication and
                  otherwise manage user accounts.{" "}
                </strong>
                We may process your information so you can create and log in to
                your account, as well as keep your account in working order.
              </li>
            </ul>
            <ul role="list">
              <li>
                <strong>
                  To deliver and facilitate delivery of services to the user.{" "}
                </strong>
                We may process your information to provide you with the
                requested service.
              </li>
            </ul>
            <ul role="list">
              <li>
                <strong>
                  To evaluate and improve our Services, products, marketing, and
                  your experience.
                </strong>{" "}
                We may process your information when we believe it is necessary
                to identify usage trends, determine the effectiveness of our
                promotional campaigns, and to evaluate and improve our Services,
                products, marketing, and your experience.
              </li>
            </ul>
            <ul role="list">
              <li>
                <strong>To identify usage trends.</strong> We may process
                information about how you use our Services to better understand
                how they are being used so we can improve them.
              </li>
            </ul>
            <ul role="list">
              <li>
                <strong>
                  To determine the effectiveness of our marketing and
                  promotional campaigns.
                </strong>{" "}
                We may process your information to better understand how to
                provide marketing and promotional campaigns that are most
                relevant to you.
              </li>
            </ul>
            <p>
              <strong>
                3. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?
              </strong>
            </p>
            <p>
              <strong>
                <em>In Short:</em>
              </strong>
              <em>
                {" "}
                We may share information in specific situations described in
                this section and/or with the following third parties.
              </em>
            </p>
            <p>
              We may need to share your personal information in the following
              situations:
            </p>
            <ul role="list">
              <li>
                <strong>Business Transfers.</strong> We may share or transfer
                your information in connection with, or during negotiations of,
                any merger, sale of company assets, financing, or acquisition of
                all or a portion of our business to another company.
              </li>
            </ul>
            <ul role="list">
              <li>
                <strong>When we use Google Maps Platform APIs.</strong> We may
                share your information with certain Google Maps Platform APIs
                (e.g., Google Maps API, Places API). Google Maps uses GPS,
                Wi-Fi, and cell towers to estimate your location. GPS is
                accurate to about 20 meters, while Wi-Fi and cell towers help
                improve accuracy when GPS signals are weak, like indoors. This
                data helps Google Maps provide directions, but it is not always
                perfectly precise.
              </li>
            </ul>
            <p>
              <strong>
                4. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?
              </strong>
            </p>
            <p>
              <strong>
                <em>In Short:</em>
              </strong>
              <em>
                {" "}
                We may use cookies and other tracking technologies to collect
                and store your information.
              </em>
            </p>
            <p>
              We may use cookies and similar tracking technologies (like web
              beacons and pixels) to gather information when you interact with
              our Services. Some online tracking technologies help us maintain
              the security of our Services and your account, prevent crashes,
              fix bugs, save your preferences, and assist with basic site
              functions.
            </p>
            <p>
              We also permit third parties and service providers to use online
              tracking technologies on our Services for analytics and
              advertising, including to help manage and display advertisements,
              to tailor advertisements to your interests, or to send abandoned
              shopping cart reminders (depending on your communication
              preferences). The third parties and service providers use their
              technology to provide advertising about products and services
              tailored to your interests which may appear either on our Services
              or on other websites.
            </p>
            <p>
              Specific information about how we use such technologies and how
              you can refuse certain cookies is set out in our Cookie Notice.
            </p>
            <p>
              <strong>5. HOW DO WE HANDLE YOUR SOCIAL LOGINS?</strong>
            </p>
            <p>
              <strong>
                <em>In Short: </em>
              </strong>
              <em>
                If you choose to register or log in to our Services using a
                social media account, we may have access to certain information
                about you.
              </em>
            </p>
            <p>
              Our Services offer you the ability to register and log in using
              your third-party social media account details (like your Facebook
              or X logins). Where you choose to do this, we will receive certain
              profile information about you from your social media provider. The
              profile information we receive may vary depending on the social
              media provider concerned, but will often include your name, email
              address, friends list, and profile picture, as well as other
              information you choose to make public on such a social media
              platform.
            </p>
            <p>
              We will use the information we receive only for the purposes that
              are described in this Privacy Notice or that are otherwise made
              clear to you on the relevant Services. Please note that we do not
              control, and are not responsible for, other uses of your personal
              information by your third-party social media provider. We
              recommend that you review their privacy notice to understand how
              they collect, use, and share your personal information, and how
              you can set your privacy preferences on their sites and apps.
            </p>
            <p>
              <strong>6. HOW LONG DO WE KEEP YOUR INFORMATION?</strong>
            </p>
            <p>
              <strong>
                <em>In Short: </em>
              </strong>
              <em>
                We keep your information for as long as necessary to fulfill the
                purposes outlined in this Privacy Notice unless otherwise
                required by law.
              </em>
            </p>
            <p>
              We will only keep your personal information for as long as it is
              necessary for the purposes set out in this Privacy Notice, unless
              a longer retention period is required or permitted by law (such as
              tax, accounting, or other legal requirements). No purpose in this
              notice will require us keeping your personal information for
              longer than __________ months past the termination of the user's
              account.
            </p>
            <p>
              When we have no ongoing legitimate business need to process your
              personal information, we will either delete or anonymize such
              information, or, if this is not possible (for example, because
              your personal information has been stored in backup archives),
              then we will securely store your personal information and isolate
              it from any further processing until deletion is possible.
            </p>
            <p>
              <strong>7. HOW DO WE KEEP YOUR INFORMATION SAFE?</strong>
            </p>
            <p>
              <strong>
                <em>In Short: </em>
              </strong>
              <em>
                We aim to protect your personal information through a system of
                organizational and technical security measures.
              </em>
            </p>
            <p>
              We have implemented appropriate and reasonable technical and
              organizational security measures designed to protect the security
              of any personal information we process. However, despite our
              safeguards and efforts to secure your information, no electronic
              transmission over the Internet or information storage technology
              can be guaranteed to be 100% secure, so we cannot promise or
              guarantee that hackers, cybercriminals, or other unauthorized
              third parties will not be able to defeat our security and
              improperly collect, access, steal, or modify your information.
              Although we will do our best to protect your personal information,
              transmission of personal information to and from our Services is
              at your own risk. You should only access the Services within a
              secure environment.
            </p>
            <p>
              <strong>8. DO WE COLLECT INFORMATION FROM MINORS?</strong>
            </p>
            <p>
              <strong>
                <em>In Short:</em>
              </strong>
              <em>
                {" "}
                We do not knowingly collect data from or market to children
                under 18 years of age.
              </em>
            </p>
            <p>
              We do not knowingly collect, solicit data from, or market to
              children under 18 years of age, nor do we knowingly sell such
              personal information. By using the Services, you represent that
              you are at least 18 or that you are the parent or guardian of such
              a minor and consent to such minor dependent’s use of the Services.
              If we learn that personal information from users less than 18
              years of age has been collected, we will deactivate the account
              and take reasonable measures to promptly delete such data from our
              records. If you become aware of any data we may have collected
              from children under age 18, please contact us at
              support@hightable.ai.
            </p>
            <p>
              <strong>9. WHAT ARE YOUR PRIVACY RIGHTS?</strong>
            </p>
            <p>
              <strong>
                <em>In Short:</em>
              </strong>
              <em>
                {" "}
                You may review, change, or terminate your account at any time,
                depending on your country, province, or state of residence.
              </em>
            </p>
            <p>
              <strong>Withdrawing your consent:</strong> If we are relying on
              your consent to process your personal information, which may be
              express and/or implied consent depending on the applicable law,
              you have the right to withdraw your consent at any time. You can
              withdraw your consent at any time by contacting us by using the
              contact details provided in the section "
              <a href="#contact">HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</a>"
              below.
            </p>
            <p>
              However, please note that this will not affect the lawfulness of
              the processing before its withdrawal nor, when applicable law
              allows, will it affect the processing of your personal information
              conducted in reliance on lawful processing grounds other than
              consent.
            </p>
            <p>
              <strong>
                Opting out of marketing and promotional communications:{" "}
              </strong>
              You can unsubscribe from our marketing and promotional
              communications at any time by clicking on the unsubscribe link in
              the emails that we send, or by contacting us using the details
              provided in the section "
              <a href="#contact">HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</a>"
              below. You will then be removed from the marketing lists. However,
              we may still communicate with you — for example, to send you
              service-related messages that are necessary for the administration
              and use of your account, to respond to service requests, or for
              other non-marketing purposes.
            </p>
            <p>
              <strong>Account Information</strong>
            </p>
            <p>
              If you would at any time like to review or change the information
              in your account or terminate your account, you can:
            </p>
            <ul role="list">
              <li>
                Log in to your account settings and update your user account.
              </li>
            </ul>
            <p>
              Upon your request to terminate your account, we will deactivate or
              delete your account and information from our active databases.
              However, we may retain some information in our files to prevent
              fraud, troubleshoot problems, assist with any investigations,
              enforce our legal terms and/or comply with applicable legal
              requirements.
            </p>
            <p>
              <strong>Cookies and similar technologies:</strong> Most Web
              browsers are set to accept cookies by default. If you prefer, you
              can usually choose to set your browser to remove cookies and to
              reject cookies. If you choose to remove cookies or reject cookies,
              this could affect certain features or services of our Services.
            </p>
            <p>
              If you have questions or comments about your privacy rights, you
              may email us at support@hightable.ai.
            </p>
            <p>
              <strong>10. CONTROLS FOR DO-NOT-TRACK FEATURES</strong>
            </p>
            <p>
              Most web browsers and some mobile operating systems and mobile
              applications include a Do-Not-Track ("DNT") feature or setting you
              can activate to signal your privacy preference not to have data
              about your online browsing activities monitored and collected. At
              this stage, no uniform technology standard for recognizing and
              implementing DNT signals has been finalized. As such, we do not
              currently respond to DNT browser signals or any other mechanism
              that automatically communicates your choice not to be tracked
              online. If a standard for online tracking is adopted that we must
              follow in the future, we will inform you about that practice in a
              revised version of this Privacy Notice.
            </p>
            <p>
              <strong>11. DO WE MAKE UPDATES TO THIS NOTICE?</strong>
            </p>
            <p>
              <strong>
                <em>In Short: </em>
              </strong>
              <em>
                Yes, we will update this notice as necessary to stay compliant
                with relevant laws.
              </em>
            </p>
            <p>
              We may update this Privacy Notice from time to time. The updated
              version will be indicated by an updated "Revised" date at the top
              of this Privacy Notice. If we make material changes to this
              Privacy Notice, we may notify you either by prominently posting a
              notice of such changes or by directly sending you a notification.
              We encourage you to review this Privacy Notice frequently to be
              informed of how we are protecting your information.
            </p>
            <p id="about-us">
              <strong>12. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</strong>
            </p>
            <p>
              If you have questions or comments about this notice, you may email
              us at &nbsp;
              <strong>
                <a
                  className="text-blue-500 underline"
                  href="mailto:support@hightable.ai"
                >
                  support@hightable.ai
                </a>
              </strong>{" "}
              or contact us by post at:
            </p>
            <p>High Table Network Private Limited</p>
            <p>
              Adya 13 &amp; 14, No 4, 6 Cross, 9th Main, Srinivagilu Main Road
            </p>
            <p>Near Koramangala bus depot, Koramangala</p>
            <p>Bangalore, Karnataka 560047</p>
            <p>India</p>
            <p>
              <strong>
                13. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT
                FROM YOU?
              </strong>
            </p>
            <p>
              You have the right to request access to the personal information
              we collect from you, details about how we have processed it,
              correct inaccuracies, or delete your personal information. You may
              also have the right to withdraw your consent to our processing of
              your personal information. These rights may be limited in some
              circumstances by applicable law. To request to review, update, or
              delete your personal information, please visit: www.hightable.ai
            </p>
            <p>‍</p>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Privacy;
